import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import organizationService from "services/organizationService";
import {
  RenderOrganization,
  RenderOrganizationInTable,
} from "utils/RenderOrganization";
import ListingTitle from "components/ListingTitle";
import { Card } from "components/Card";
import Label from "components/Label";
import Dropdown from "components/Dropdown";
import ToggleButtonComponent from "components/ToggleButtonComponent";
import CurrentFilter from "components/CurrentFilter";
import InputComponent from "components/InputComponent";
import ButtonComponent from "components/ButtonComponent";
import { ModalComponent } from "components/ModalComponent";
import { InviteOrganization, AddUserForm } from "components/Forms";
import Loader from "components/Loader";
import AlertComponent from "components/AlertComponent";
import authService from "services/authService";
import { useNavigate } from "react-router-dom";

function Organisations() {
  const [numericOrganization, setNumericOrganization] = useState([]);
  const [alphabeticOrganization, setAlphabeticOrganization] = useState([]);
  const [blockedOrganization, setBlockedOrganization] = useState([]);
  const [allOrganization, setAllOrganization] = useState([]);
  const [alignment, setAlignment] = useState("left");
  const [inviteModal, setInviteModal] = useState(false);
  const [addUserModal, setAddUserModal] = useState(false);
  const [newOrgId, setNewOrgId] = useState(null);
  const [openLoaderModal, setOpenLoaderModal] = useState(false);
  const [enableSearchButton, setEnableSearchButton] = useState(true);
  const [sortBy, setSortBy] = useState(0);
  const [searchInputField, setSearchInputField] = useState("");
  const [searchTitleData, setSearchTitleData] = useState([]);
  // const [searchItemArray, setSearchItemArrays] = useState({});
  const [searchItemArray, setSearchItemArrays] = useState([]);
  const navigate = useNavigate();

  const [stateAlert, setStateAlert] = useState({
    inviteOrganizationError: false,
    inviteOrganizationSuccess: false,
    alertStatename: "",
    mesage: "",
    varient: "info",
  });
  const closeAlertModel = (statename) => {
    setStateAlert((prev) => ({
      ...prev,
      [statename]: false,
    }));
  };
  const openAlertModel = (statename, message, variant, alertstateName) => {
    setStateAlert((prev) => ({
      ...prev,
      [statename]: true,
      mesage: message,
      varient: variant,
      alertStatename: alertstateName,
    }));
  };
  const isBlocked = false;
  const alignmenthandle = (value) => {
    setAlignment(value);
  };
  const handleModal = () => {
    setInviteModal(true);
  };

  useEffect(() => {
    if (searchInputField) {
      setSearchTitleData([]);
      organizationService
        .handleSearchTitle(searchInputField)
        .then((res) => {
          setSearchTitleData(res.data.results);
        })
        .catch(() => {
          setSearchTitleData([]);
        });
    } else {
      setSearchTitleData([]);
    }
  }, [searchInputField]);

  const fetchAllApiData = async (customSort = null) => {
    try {
      const sortParam = customSort !== null ? customSort : null;

      const requests =
        sortParam !== null
          ? [
              organizationService.getNumericOrganization(sortParam),
              organizationService.getAlphabeticalOrganization(sortParam),
              organizationService.getBlockedOrganizations(sortParam),
              organizationService.getOrganizations(sortParam),
            ]
          : [
              organizationService.getNumericOrganization(),
              organizationService.getAlphabeticalOrganization(),
              organizationService.getBlockedOrganizations(),
              organizationService.getOrganizations(),
            ];

      const [numRes, alphaRes, blockedRes, allRes] = await Promise.all(
        requests
      );

      if (numRes.status === 200) setNumericOrganization(numRes.data);
      if (alphaRes.status === 200) setAlphabeticOrganization(alphaRes.data);
      if (blockedRes.status === 200)
        setBlockedOrganization(blockedRes.data.results);
      if (allRes.status === 200) setAllOrganization(allRes.data.results);
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/");
      } else {
        console.warn("Error fetching organizations:", err);
      }
    }
  };

  useEffect(() => {
    const accessToken = localStorage.getItem("token");

    if (!accessToken) {
      localStorage.removeItem("token");
      navigate("/");
      return;
    }

    const isTokenExpired = (token) => {
      try {
        const [, payload] = token.split(".");
        const decoded = JSON.parse(atob(payload));
        return decoded.exp * 1000 < Date.now();
      } catch {
        return true;
      }
    };

    if (isTokenExpired(accessToken)) {
      localStorage.removeItem("token");
      navigate("/");
      return;
    }

    fetchAllApiData();
  }, [navigate]);

  const addNewOrganization = (data) => {
    setOpenLoaderModal(true);
    organizationService
      .addNewOrganization(data)
      .then((res) => {
        setOpenLoaderModal(false);
        setInviteModal(false);
        if (res.status === 201) {
          openAlertModel(
            "inviteOrganizationSuccess",
            "Add Organization Successfuly",
            "success",
            "inviteOrganizationSuccess"
          );
          fetchAllApiData();
          setNewOrgId(res.data.id);
          setAddUserModal(true);
        }
      })
      .catch(() => {
        setOpenLoaderModal(false);
        setInviteModal(false);
        openAlertModel(
          "inviteOrganizationError",
          "Add Organization Successfuly",
          "error",
          "inviteOrganizationError"
        );
      });
  };

  const addNewUserToOrg = ({
    email,
    first_name,
    last_name,
    username,
    userImage,
  }) => {
    setOpenLoaderModal(true);
    authService
      .addNewUser({
        email,
        first_name,
        last_name,
        username,
        organizationId: newOrgId,
        userImage,
      })
      .then((res) => {
        setOpenLoaderModal(false);
        if (res.status === 201) {
          openAlertModel(
            "inviteOrganizationSuccess",
            "New user added successfully!",
            "success",
            "inviteOrganizationSuccess"
          );
          setAddUserModal(false);
          fetchAllApiData();
        }
      })
      .catch(() => {
        setOpenLoaderModal(false);
        openAlertModel(
          "inviteOrganizationError",
          "Error while adding new user. User with this email already exists!",
          "error",
          "inviteOrganizationError"
        );
      });
  };
  // const handleSortBtnFunction = (e) => {
  //   setSortBy(e.target.value);
  //   setEnableSearchButton(!searchItemArray.length);
  // };
  const handleSortBtnFunction = (eOrValue) => {
    const rawValue = eOrValue?.target ? eOrValue.target.value : eOrValue;
    const value = Number(rawValue);
    setSortBy(value);
    setEnableSearchButton(!searchItemArray.length);
    fetchAllApiData(value);
  };
  const handleSerachInputField = (e) => {
    setSearchInputField(e.target.value);
  };
  // const handleSearchItemArray = (item) => {
  //   if (searchItemArray.length > 0) {
  //     const isExistItem = searchItemArray.some(
  //       (data) => data.item.id === item.id
  //     );
  //     setSearchTitleData([]);
  //     setSearchInputField("");
  //     if (!isExistItem) {
  //       setEnableSearchButton(false);
  //       setSearchItemArrays([...searchItemArray, { item }]);
  //     }
  //   } else {
  //     setSearchTitleData([]);
  //     setSearchInputField("");
  //     setEnableSearchButton(false);
  //     setSearchItemArrays([...searchItemArray, { item }]);
  //   }
  // };
  const handleSearchItemArray = (item) => {
    const safeArray = Array.isArray(searchItemArray) ? searchItemArray : [];

    setSearchTitleData([]);
    setSearchInputField("");

    const isExistItem = safeArray.some((data) => data.item.id === item.id);
    if (!isExistItem) {
      setEnableSearchButton(false);
      setSearchItemArrays([...safeArray, { item }]);
    }
  };

  const ClearItemTitleData = (data) => {
    if (data) {
      const afterClear = searchItemArray.filter((items) => {
        return items.item.id !== data.item.id;
      });
      setSearchItemArrays(afterClear);

      if (searchItemArray.length === 1) {
        setEnableSearchButton(true);
      }
    } else {
      fetchAllApiData();
      setSearchItemArrays([]);
      setEnableSearchButton(true);
    }
  };
  const searchFilterApiData = () => {
    let filterTitles = "";
    searchItemArray.forEach((data) => {
      if (filterTitles === "") {
        filterTitles = `${data.item.title}`;
      } else {
        filterTitles = `${filterTitles},${data.item.title}`;
      }
    });
    const Filterdata = {
      sortBy,
      filterTitles,
    };

    organizationService.filterNumericOrganizations(Filterdata).then((res) => {
      setNumericOrganization(res.data);
    });
    organizationService
      .filterAlphaNumericOrganizations(Filterdata)
      .then((res) => {
        setAlphabeticOrganization(res.data);
      });
    organizationService.filterGetOrganizations(Filterdata).then((res) => {
      setAllOrganization(res.data.results);
    });

    organizationService.filterLockOrganizations(Filterdata).then((res) => {
      setBlockedOrganization(res.data.results);
    });
  };
  let searchButtonClass = "search-organization-disable";
  if (!enableSearchButton) {
    searchButtonClass = "search-organization";
  }
  return (
    <div className="b-listing-container">
      {/* Loader */}
      <Loader title="Adding Organization" openLoader={openLoaderModal} />
      {/* Alert */}
      <AlertComponent
        title={stateAlert.mesage}
        msg={stateAlert.varient}
        handleCloseAlert={() => closeAlertModel(stateAlert.alertStatename)}
        openAlert={stateAlert[stateAlert.alertStatename]}
      />
      <Grid container spacing={1}>
        <Grid item xs={12} md={4}>
          <div className="b-filter-container">
            {/* Buttons */}

            <ButtonComponent
              Icon={<AddIcon className="tag-button-icon" />}
              cssName="invite-new"
              title="Invite New Organization"
              enableSearchBtn={!enableSearchButton}
              handleButtonClick={handleModal}
            />

            <div className="b-btn-container__search-section" />
            <ButtonComponent
              Icon={<SearchIcon className="tag-button-icon" />}
              cssName={searchButtonClass}
              title="Search For An Organization"
              enableSearchBtn={enableSearchButton}
              handleButtonClick={searchFilterApiData}
            />

            {/* Filter Card */}
            <Card
              title="Filter"
              bodyStyle="b-organization-container__headingBody"
              // isLocked="false"
              isLocked={false}
              body={
                <>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Label label="Sort By" />
                      <Dropdown
                        cssName="organization-dropdown"
                        setSortBy={handleSortBtnFunction}
                        sortBy={sortBy}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Label label="View as" />
                      <ToggleButtonComponent
                        HandleAlignment={alignmenthandle}
                      />
                    </Grid>
                  </Grid>
                  <CurrentFilter
                    filters={searchItemArray}
                    clearDataFun={ClearItemTitleData}
                  />
                  <InputComponent
                    onChange={handleSerachInputField}
                    searchInputField={searchInputField}
                    searchTitleData={searchTitleData}
                    setSearchItemArray={handleSearchItemArray}
                  />
                </>
              }
            />
          </div>
        </Grid>

        <Grid item xs={12} md={8}>
          <div className="b-listing-container__list-section">
            {alignment === "left" ? (
              <>
                {/* Locked Organization Organization  */}
                <ListingTitle
                  title="Locked Organizations"
                  showIcon="true"
                  cssName="b-listing-container__locked-title"
                  fontColor="#000000"
                />
                {blockedOrganization?.length > 0 && (
                  <Grid container spacing={2}>
                    {blockedOrganization.map((org) => (
                      <Grid item xs={12} md={6} key={org.id}>
                        {RenderOrganization(org, fetchAllApiData)}
                      </Grid>
                    ))}
                  </Grid>
                  // {blockedOrganization.map((org, index) => (
                  //   <Grid item xs={12} md={6} key={index}>
                  //     {RenderOrganization(org, fetchAllApiData)}
                  //   </Grid>
                  // ))}
                )}

                {/* Numerical Organization  */}
                <ListingTitle
                  title="Numerical"
                  showIcon="false"
                  cssName="2px solid #005298"
                  fontColor="#005298"
                />
                {numericOrganization.length > 0 && (
                  <Grid container spacing={1}>
                    {numericOrganization.map((org) => (
                      <Grid item xs={12} md={6} key={org.id}>
                        {RenderOrganization(org, fetchAllApiData)}
                      </Grid>
                    ))}
                  </Grid>
                )}

                {/* Alpha Numerical Organization  */}
                <ListingTitle
                  title="Alphabetic"
                  showIcon="false"
                  cssName="2px solid #005298"
                  fontColor="#005298"
                />
                {alphabeticOrganization.length > 0 && (
                  <Grid container spacing={1}>
                    {alphabeticOrganization.map((org) => (
                      <Grid item xs={12} md={6} key={org.id}>
                        {RenderOrganization(org, fetchAllApiData)}
                      </Grid>
                    ))}
                  </Grid>
                )}
              </>
            ) : (
              <>
                {allOrganization.length > 0 &&
                  RenderOrganizationInTable(blockedOrganization, true)}
                <div>
                  {allOrganization.length > 0 &&
                    RenderOrganizationInTable(allOrganization, false)}
                </div>
              </>
            )}
          </div>
        </Grid>
      </Grid>
      {/* Invite new Organization Modal */}
      <ModalComponent
        title="Invite New Organization"
        isLocked={isBlocked}
        openModal={inviteModal}
        handleCloseModal={() => setInviteModal(false)}
        ModalBody={<InviteOrganization handleResponse={addNewOrganization} />}
      />
      {/* Add User to new Organization Modal */}
      <ModalComponent
        title="Add User to Organization"
        isLocked={isBlocked}
        openModal={addUserModal}
        handleCloseModal={() => setAddUserModal(false)}
        ModalBody={
          newOrgId ? (
            <AddUserForm handleResponse={addNewUserToOrg} orgId={newOrgId} />
          ) : null
        }
      />
    </div>
  );
}

export default Organisations;
